import React from "react";
import Image from "components/image";

const WishlistToast = ({ image, defaultImage, listsToAdd, listsToRemove, }) => {
	const successMessage =
		listsToAdd > 0
			? `Product ${listsToAdd === 1 ? "added" : "added"} successfully to ${listsToAdd} list${listsToAdd > 1 ? "s" : ""}.`
			: `Product removed successfully from ${listsToRemove} list${listsToRemove > 1 ? "s" : ""}.`;

	return (
		<div className="cursor-pointer">
			<div className="flex gap-2">
				{image ?
					<Image image={image} className="size-16" />
					:
					<img src={defaultImage} className="size-16" loading="lazy" />
				}
				<p>{successMessage}</p>
			</div>
		</div>
	);
};

export default WishlistToast;